import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'comaDecimalPipe'
})
export class ComaDecimalPipePipe implements PipeTransform {

  transform(value: number | string): string {
    if (value == null || value === '') return '';

    const numero = typeof value === 'string' ? parseFloat(value) : value;

    // Redondeamos a 2 decimales
    const [entero, decimales] = numero.toFixed(2).split('.');

    // Si los decimales son "00", devolvemos solo el número entero
    if (decimales === '00') {
      return entero;
    }

    return `${entero},${decimales}`;
  }
}
